import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { SedsHeaderLogoComponent } from './seds-header-logo.component';

@NgModule({
  declarations: [SedsHeaderLogoComponent],
  imports: [CommonModule],
  exports: [SedsHeaderLogoComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SedsHeaderLogoModule {}
